












































































































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import {GetTenantInfo} from '../../api/realTime'
import myTable from '../../components/table/my-table.vue'
import {EMRPatientInfo} from '../../api/realTime'
import patientDetails from './patientDetails.vue'
@Component({
    components: {myTable,patientDetails}
})
export default class extends AbpBase {
    @Watch('activeName')
    refreshfun(){
        this.refresh = false
        this.$nextTick(()=>{
            this.refresh = true
        })
    }
    detailactiveName = '基本信息'
    refresh = false
    created(){
        this.getSelects()
        this.getData()
    }
    option = {}
    queryform = {
        tenantIds:[],
        pageSize:20,
        page:1,
        total:0,
        patientStr:'',
        sex:'',
        isDelFlag:null,
        isTemp:null,
        ageMin:null,
        ageMax:null,
        dialysisMin:null,
        dialysisMax:null,
        accessType:'',
        bodySide:'',
        pathwayPosition:'',
        orderByType:null,
    }
    tenantOptions = []
    //获取下拉框
    async getSelects(){
        this.tenantOptions = (await GetTenantInfo({})).data
    }
    searchPopShow = false
    tabs:any = [
        {closable:false,key:0,name:'患者列表',id:null,detailName:''},
    ]
    activeName = `患者列表`
    patientId = null
    removeTab(targetName){
        let ri;
        this.tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
                if (nextTab) {
                    this.activeName = nextTab.name;
                    this.patientId = nextTab.patientId
                }
                ri = index
            }
        });
        this.tabs.splice(ri,1)
    }
    detail(row:any){
        let tab = this.tabs.find((item:any)=>{return item.name == row.patientName})
        if(tab){
            this.activeName = row.patientName
            this.patientId = row.patientId
            this.detailactiveName = tab.detailName
            return false 
        }
        this.tabs.push({
            closable:true,
            key:0,
            name:row.patientName,
            id:row.patientId,
            detailName:'基本信息'
        })
        this.activeName = row.patientName
        this.patientId = row.patientId
        this.detailactiveName = '基本信息'
    }
    detailtabsChange(name){
        let tab = this.tabs.find((item:any)=>{return item.name == this.activeName})
        tab.detailName = name
    }
    tabChange(){
        let tab = this.tabs.find((item:any)=>{return item.name == this.activeName})
        this.detailactiveName = tab.detailName
        this.patientId = tab.id
    }
    pageChange(page:number){
        this.queryform.page = page
        this.getData();
    }
    pagesizeChange(pagesize:number){
        this.queryform.pageSize = pagesize
        this.getData();
    }
    sortChange(column, prop, order){
        console.log(column, prop, order)
    }
    list = []
    columns = [
        {
            title:'姓名',
            key:'patientName',
            sortable:'custom',
            render:(h:any,p:any)=>{
                return h('span',{
                    style:{
                        color:'#409EFF',
                        cursor: 'pointer',
                    },
                    on:{
                        'click':()=>{
                            this.detail(p.row)
                        }
                    }
                },p.row.patientName)
            }
        },
        {
            title:'年龄',
            key:'age',
            sortable:'custom',
        },
        {
            title:'透龄',
            key:'dialysisYear',
            sortable:'custom',
        },
        {
            title:'性别',
            key:'sex',
        },
        {
            title:'通路信息',
            key:'accessInfo',
        },
        {
            title:'诊断',
            key:'diagnosis',
            width:800,
        },
        {
            title:'传染病',
            key:'contagion',
        },
    ]
    async getData(){
        this.table.loading = true
        let res = await EMRPatientInfo(this.queryform)
        this.list = res.data.emrPatientDetail
        this.queryform.total = res.data.count
        this.table.loading = false
    }
}
